import { useState, useRef } from "react";
import { Alert, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { uploadDocumentoProps } from "../../../../../../../../service/uploadService";
import { toast } from "react-toastify";

const { Dragger } = Upload;

export function ImportDocumentos({ numeroSolicitacao, fetchListDocumento, setImportarDocumentosDaOS }) {
  const modalRef = useRef(null);
  const [documentos, setDocumentos] = useState([]);



  // Função para buscar os documentos
  const loadDocumentos = async () => {
    try {
      const docs = await fetchListDocumento(numeroSolicitacao);
      setDocumentos(docs);
      setImportarDocumentosDaOS(false);
    } catch (error) {
      toast.error("Erro ao carregar documentos.");
    }
  };

  // Configuração do upload com callback para atualizar os documentos
  const uploadDoc = uploadDocumentoProps(
    numeroSolicitacao,
    "/ordem-servico/documento/upload",
    loadDocumentos // Atualiza os documentos ao concluir o upload
  );

  return (
    <>

      <div className="padding-10-container">

        <div style={{marginBottom: 10}}>
          <Alert message="Intruções"
          description="Selecione o arquivo que desejar disponibilizar para o cliente."
          type="info"
          showIcon />
          </div>

        <div>
          <div className="padding-5">
            <Dragger {...uploadDoc}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Clique ou arraste o arquivo aqui
              </p>
              <p className="ant-upload-hint">
                Suporte para upload de um ou múltiplos arquivos. Apenas PDFs
                permitidos.
              </p>
            </Dragger>
          </div>
        </div>
      </div>

    </>
  );
}

export default ImportDocumentos;
